import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '@/services/apiService';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import listMixin from '../../niotaClassic/listMixin';
import listOptionsPersistenceMixin from '@/components/custom/listOptionsPersistenceMixin';
import iconsMixin from '@/components/core/dtwin/state/bridge/iconsMixin';
import { userItemsPerListMixin, isCopyToClipboardSupported, copyToClipboard as _copyToClipboard } from '@/utils/vuex';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import axios from 'axios';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreVirtualDeviceList',
  mixins: [listMixin, listOptionsPersistenceMixin, iconsMixin, userItemsPerListMixin],
  props: {
    favouriteFilterEnabled: {
      type: Boolean,
      required: true
    },
    accounts: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    searchTypes: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    predefinedSearch: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    // if used in the device-type list, do not restore the last filter from the virtual-device-list
    // should show ALL unfiltered devices by default
    restoreFilter: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },
    containerClass: {
      type: String,
      default: function _default() {
        return 'n20-mainrow';
      },
      required: false
    },
    initSearchItems: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    initOperator: {
      type: String,
      default: 'AND',
      required: false
    },
    deviceTemplate: {
      type: Object,
      default: function _default() {},
      required: false
    }
  },
  data: function data() {
    return {
      deleteDialog: false,
      deletePrompt: false,
      // "foreign" dependencies of a devicetwin that should be deleted
      deviceDependencies: {},
      deviceObject: null,
      deviceDeleteRemotely: false,
      disableFetchOnCreatedMixin: true,
      selectedAccounts: [],
      lastSearch: null,
      searchItems: [],
      searchOperator: 'AND',
      listPersistencePath: 'VirtualDevice.list',
      searchMode: 'multi',
      favouriteMode: 'on',
      showDialogCreate: false,
      isFetching: true,
      tableOptions: _objectSpread({}, defaultTableOptions),
      defaultTableOptions: _objectSpread({}, defaultTableOptions),
      selected: [],
      visibleHeaderValues: [],
      customizableColumns: [],
      fetchList: function fetchList() {},
      latestRequestId: 0,
      cancelTokenSource: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    isVirtualDeviceManager: function isVirtualDeviceManager() {
      return this.permissions['VirtualDevice.manage'];
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isEmptyList: function isEmptyList() {
      return this.predefinedSearch.length === 0 && this.searchItems.length === 0 && this.serverItemsLength <= 0 && this.isFetching === false;
    },
    headerBG: function headerBG() {
      return './img/consumer.png';
    },
    selectedRows: function selectedRows() {
      return this.list.filter(function (item) {
        return item.selected;
      });
    },
    computedVisibleHeaders: function computedVisibleHeaders() {
      var _this = this;

      return this.tableHeaders.filter(function (header) {
        // icon and actions are always visible
        if (header.show === undefined) {
          return true;
        }

        return _this.visibleHeaderValues.includes(header.value);
      });
    },
    tableHeaders: function tableHeaders() {
      var _this2 = this;

      return [{
        sortable: false,
        value: 'icon' // hide: 'mdAndDown',

      }, {
        text: "".concat(this.$i18n_t('Common.id')),
        value: 'id',
        sortable: true,
        show: true
      }, {
        text: "".concat(this.$i18n_t('DigitalTwin.VirtualDevice.props.title')),
        value: 'title',
        sortable: true,
        show: true
      }, {
        text: "".concat(this.$i18n_t('DigitalTwin.VirtualDevice.props.account')),
        value: 'tenant.name',
        sortable: false,
        show: false
      }, {
        text: "".concat(this.$i18n_t('DigitalTwin.VirtualDevice.props.address')),
        value: 'data.address.formatted_address',
        sortable: true,
        show: false
      }, {
        text: "".concat(this.$i18n_t('DigitalTwin.VirtualDevice.props.createdAt')),
        value: 'createdAt',
        sortable: true,
        show: false
      }, {
        text: "".concat(this.$i18n_t('DigitalTwin.VirtualDevice.props.updatedAt')),
        value: 'updatedAt',
        sortable: true,
        show: false
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.type'),
        value: 'bridge.type',
        sortable: true,
        // hide: 'mdAndDown',
        show: true
      }, this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback') ? {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.deviceType'),
        value: 'deviceType',
        sortable: true,
        show: true
      } : {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.deviceDriver'),
        value: 'deviceDriver',
        sortable: true,
        show: true
      }, {
        text: this.$i18n_t('IS.AssetMgmt.list.lastSeen'),
        value: 'lastSeen',
        // hide: 'mdAndDown',
        sortable: true,
        show: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.deviceId'),
        value: 'deviceId',
        sortable: true,
        show: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.operationalStatusShort'),
        value: 'operationalStatus',
        // hide: 'mdAndDown',
        sortable: true,
        show: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.health'),
        value: 'health',
        sortable: true,
        show: true
      }, {
        text: '',
        value: 'actions',
        sortable: false,
        width: '60',
        align: 'right'
      }].filter(function (item) {
        return !item.hide || !_this2.$vuetify.breakpoint[item.hide];
      });
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50, 100, 200]
      };
    },
    featureFlagDeviceTypeFallbackEnabled: function featureFlagDeviceTypeFallbackEnabled() {
      return this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback');
    },
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    canDeleteDevice: function canDeleteDevice() {
      return this.deviceDependencies && (get(this.deviceDependencies, 'aggregatedStates') || []).length === 0;
    }
  }),
  watch: {
    initSearchItems: {
      handler: function handler(val) {
        this.searchItems = val;
        this.setSelected(val);
      },
      deep: true
    },
    initOperator: {
      handler: function handler(val) {
        this.searchOperator = val;
      }
    },
    favouriteFilterEnabled: {
      handler: function handler() {
        this.fetchList(true);
      }
    },
    accounts: {
      handler: function handler() {
        this.fetchList(true);
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.isFetching = true;
    this.fetchList = debounce(this._fetchList, 500);
    this.searchItems = this.initSearchItems;
    this.searchOperator = this.initOperator;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
    this.$parent.$on('close-step-form', function () {
      return _this3.selected = [];
    });
  },
  mounted: function mounted() {
    this.setInitialCustomizableColumns();
    this.initializeColumns();
  },
  methods: {
    get: get,
    showDeleteExternalService: function showDeleteExternalService(item) {
      var type = get(item, 'properties.bridge.type', null);
      return !['bridge-mqtt', 'bridge-incomingwebhook', 'bridge-webhook', 'bridge-wireless-mbus-decoder'].includes(type);
    },
    setInitialCustomizableColumns: function setInitialCustomizableColumns() {
      this.customizableColumns = this.tableHeaders.filter(function (header) {
        return header.show !== undefined && !header.hide;
      }).map(function (header) {
        return {
          text: header.text,
          value: header.value,
          show: header.show
        };
      });
    },
    initializeColumns: function initializeColumns() {
      var _this4 = this;

      try {
        // Get saved columns from local storage and parse as JSON
        var getSaveColumns = JSON.parse(localStorage.getItem('vd_list_cols'));

        if (!getSaveColumns) {
          // Throw error if storage key is not found or empty to set default columns
          throw new Error('No saved columns or invalid format');
        } // Set visible columns to saved columns


        this.visibleHeaderValues = getSaveColumns; // Set customizable columns `show` to true for saved columns

        this.customizableColumns.map(function (column) {
          column.show = _this4.visibleHeaderValues.includes(column.value);
        });
      } catch (e) {
        // Set visible columns to default columns
        this.handleColumnUpdate(this.tableHeaders);
      }
    },
    handleColumnUpdate: function handleColumnUpdate(columns) {
      this.visibleHeaderValues = columns.filter(function (column) {
        return column.show;
      }).map(function (column) {
        return column.value;
      });
      localStorage.setItem('vd_list_cols', JSON.stringify(this.visibleHeaderValues));
    },
    showParentsCreateDialog: function showParentsCreateDialog() {
      this.$parent.showDialogCreate = true;
    },
    showDeletePrompt: function showDeletePrompt(item) {
      this.deviceObject = item;
      this.deviceDeleteRemotely = false;
      this.fetchDeviceDependencies(this.deviceObject);
      this.deletePrompt = true;
    },
    setSelected: function setSelected(rows) {
      this.$emit('update-selected-rows', rows);
    },
    initializedDefaultPageFilters: function initializedDefaultPageFilters() {
      this.$emit('loaded-favourite-filter', this.favouriteFilter || false);

      if (!this.disableFetchOnCreatedMixin) {
        this.fetchList();
      }
    },
    isCopySupported: function isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard: function copyToClipboard(event, copyValue) {
      event.stopPropagation();

      _copyToClipboard(copyValue);
    },
    relativeTime: function relativeTime(date) {
      if (date) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(date).fromNow();
      }

      return '-';
    },
    _fetchList: function _fetchList() {
      var _this5 = this;

      var fromStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Operation canceled due to a new request.');
      }

      this.cancelTokenSource = axios.CancelToken.source();
      var requestId = ++this.latestRequestId;
      this.isFetching = true;
      var searchItems = (this.predefinedSearch || []).concat(this.searchItems).map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });

      if (!isEqual(this.lastSearch, JSON.stringify(searchItems))) {
        this.lastSearch = JSON.stringify(searchItems);
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var tableOptions = fromStart ? _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      }) : this.tableOptions; // persist options for next call of this page (during this browser-tab-session)

      this.$store.state.app.pageFilters = _objectSpread(_objectSpread({}, this.$store.state.app.pageFilters), {}, {
        VirtualDevice: _objectSpread(_objectSpread({}, get(this.$store.state.app, 'pageFilters.VirtualDevice') || {}), {}, {
          list: {
            searchDetails: this.searchItems,
            searchOperator: this.searchOperator,
            tableOptions: tableOptions,
            favouriteFilter: this.favouriteFilterEnabled || false
          }
        })
      }); // the bulk-editing from the list-component also calls the fetch-method,
      // it should have no effect on the DISPLAYED result, so no processing or persisting
      // thus, wrap the call to the backend here, to re-use it

      this.fetchResult(fromStart).then(function (result) {
        if (requestId !== _this5.latestRequestId) {
          return;
        }

        _this5.list = result.virtualDevices;

        if (searchItems.length) {
          _this5.tableOptions.itemsPerPage = 50;
        }

        _this5.serverItemsLength = result.totalCount;

        _this5.$emit('load-items', result);
      }).catch(function (error) {
        if (requestId === _this5.latestRequestId) {
          console.error('Error fetching virtual devices', error);
        }
      }).finally(function () {
        if (requestId === _this5.latestRequestId) {
          _this5.isFetching = false;
        }
      });
    },
    // use `paginationMode = 'load-all' to disable a LIMIT
    fetchResult: function fetchResult() {
      var _this6 = this;

      var fromStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var paginationMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var searchItems = (this.predefinedSearch || []).concat(this.searchItems).map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      var tableOptions = fromStart ? _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      }) : this.tableOptions;
      var sortBy = tableOptions.sortBy,
          sortDesc = tableOptions.sortDesc,
          page = tableOptions.page,
          itemsPerPage = tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'id';

      if (sortItem === 'data.address.formatted_address') {
        sortItem = 'address';
      }

      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : false;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = page ? page - 1 : 0;
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var filters = [{
        type: 'tenantIds',
        ids: this.accounts.map(function (acc) {
          return acc.id;
        })
      }];
      return ApiService.virtualDeviceFetch(this, // context
      null, // userId
      [], // scopeIds
      filters, this.favouriteFilterEnabled ? ['favourites'] : null, {
        variable: sortItem,
        direction: sortDirection
      }, // orderBy
      usedPage * usedItemsPerPage, // offset
      paginationMode === 'load-all' ? null : usedItemsPerPage, // limit
      searchItems, undefined, undefined, // include identifiers
      this.searchOperator, {
        cancelToken: this.cancelTokenSource.token
      }).then(function (result) {
        _this6.$emit('load-items', result);

        return result;
      }).catch(function (error) {
        if (!axios.isCancel(error)) {
          console.error('Error fetching virtual devices', error);
        }
      });
    },
    searchUpdated: function searchUpdated(search, searchOperator) {
      this.searchItems = search;
      this.searchOperator = searchOperator;
      this.fetchList(true);
      this.$emit('search-updated', this.searchItems, this.searchOperator);
    },
    fetchDeviceDependencies: function fetchDeviceDependencies(virtualDevice) {
      var _this7 = this;

      this.deviceDependencies = null;
      return ApiService.virtualDeviceGetDependencies(virtualDevice.id).then(function (deviceDependencies) {
        deviceDependencies.aggregatedStates.forEach(function (state) {
          state.children = [_objectSpread(_objectSpread({}, state.dtwin), {}, {
            icon: state.dtwin.twinType === 'virtualDevice' ? 'sensor-on' : 'dice-d8',
            isTwin: true
          })];
          state.title = "".concat(state.title, " (").concat(state.key, ")");
          state.icon = state.icon || 'layer-group';
        });
        _this7.deviceDependencies = deviceDependencies;
      });
    },
    deleteDevice: function deleteDevice(selected) {
      var _this8 = this;

      this.deleteDialog = true;
      ApiService.virtualDeviceDelete(selected.id, this.deviceDeleteRemotely).then(function () {
        _this8.deletePrompt = false;

        _this8.$snack(_this8.$i18n_t('DigitalTwin.VirtualDevice.snacks.deleteSuccess', 'success'));

        _this8.fetchList();
      }).catch(function (error) {
        console.error(error);
        var errorTranslateKey = "Error.".concat(get(error, 'response.data.message'));

        if (error.response && _this8.$i18n_t(errorTranslateKey) !== errorTranslateKey) {
          _this8.$snack(_this8.$i18n_t(errorTranslateKey), 'error');
        } else {
          _this8.$snack(_this8.$i18n_t('DigitalTwin.VirtualDevice.snacks.deleteFailed'), 'error');
        }
      }).finally(function () {
        _this8.deleteDialog = false;
      });
    }
  }
};